import React from "react";
import { ShieldCheck, ArrowRight } from "lucide-react";

/**
 * Placeholder-safe partner strip. Shows real partner logos when admin adds them,
 * otherwise shows a transparent "Applying — under review" note (same trust
 * approach as verifiers/builders).
 */
export default function PartnersStrip() {
  return (
    <section className="py-12 md:py-16 border-t mv-hairline" data-testid="partners-strip">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Trusted With — Not Alone</span></div>
        <h2 className="font-display text-2xl md:text-3xl mv-green-text mt-3 leading-[1.05]">
          We do this <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>together.</span>
        </h2>
        <p className="mt-3 max-w-2xl text-[14.5px]" style={{ color: "var(--mv-muted)" }}>
          Banks, legal firms and community groups working with MAVULA appear here once independent verification is complete.
        </p>
        <div className="mt-6 mv-card p-6 flex items-start gap-3" style={{ background: "linear-gradient(180deg, #fff, rgba(212,175,55,0.06))" }}>
          <ShieldCheck size={22} className="mv-green-text shrink-0"/>
          <div>
            <div className="font-semibold mv-green-text">Partner directory being verified.</div>
            <div className="text-[13.5px] mt-1" style={{ color: "var(--mv-muted)" }}>
              We only display partners after independent vetting. Banks, legal firms and community organisations
              interested in joining, contact us via WhatsApp +44 7424 311882.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
